export default "__VITE_ASSET__DQBHqTId__"